import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import './StaffRegistration.css';

const API_URL =
  process.env.REACT_APP_API_URL || 'https://lsdcnodejs-api.onrender.com';

const initialForm = {
  title: '',
  fullName: '',
  email: '',
  phone: '',
  department: '',
  kc_username: '',
};

/**
 * Portrait stage: presentational only.
 * A tall arched portrait with two round medallions.
 */
function PortraitStage() {
  return (
    <div className="staff-stage">
      <div className="staff-stage-rings" aria-hidden="true" />

      <span className="staff-stage-spark staff-stage-spark--a" aria-hidden="true">✦</span>
      <span className="staff-stage-spark staff-stage-spark--b" aria-hidden="true">✦</span>
      <span className="staff-stage-spark staff-stage-spark--c" aria-hidden="true">✦</span>

      <div className="staff-arch-set">
        <motion.div
          className="staff-arch"
          initial={{ opacity: 0, y: 44 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.85, ease: [0.2, 0.7, 0.2, 1] }}
        >
          <img
            src="/assets/photos\PBA_6.png"
            alt="Chief of Staff"
          />
          <span className="staff-arch-frame" aria-hidden="true" />
        </motion.div>

        <motion.div
          className="staff-medallion staff-medallion--left"
          initial={{ opacity: 0, scale: 0.6 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ delay: 0.55, duration: 0.5, ease: [0.2, 0.9, 0.3, 1.1] }}
        >
          <img
            src="/assets/photos/PBA_11.png"
            alt="Celebrant portrait"
          />
        </motion.div>

        <motion.div
          className="staff-medallion staff-medallion--right"
          initial={{ opacity: 0, scale: 0.6 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ delay: 0.7, duration: 0.5, ease: [0.2, 0.9, 0.3, 1.1] }}
        >
          <img
            src="/assets/photos/PBA_7.png"
            alt="Celebrant portrait"
          />
        </motion.div>
      </div>
    </div>
  );
}

export default function StaffRegistration() {
  const [form, setForm] = useState(initialForm);
  const navigate = useNavigate();

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [registration, setRegistration] = useState(null);

  const [showPassLookup, setShowPassLookup] = useState(false);
  const [passEmail, setPassEmail] = useState('');
  const [passLookupLoading, setPassLookupLoading] = useState(false);
  const [passLookupError, setPassLookupError] = useState('');
  const [passKCUsername, setPassKCUsername] = useState('');

  const handleChange = (event) => {
    const { name, value } = event.target;

    setForm((current) => ({
      ...current,
      [name]: value,
    }));

    if (error) {
      setError('');
    }
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

if (
  !form.title.trim() ||
  !form.fullName.trim() ||
  !form.kc_username.trim()
) {
setError(
  'Please enter your title, full name, email address, KingsChat username and phone number.'
);
      return;
    }

    setLoading(true);
    setError('');

    try {
      const response = await fetch(
        `${API_URL}/api/birthday/staff/register`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
body: JSON.stringify({
  title: form.title.trim(),
  fullName: form.fullName.trim(),
//   email: form.email.trim(),
//   phone: form.phone.trim(),
//   department: form.department.trim(),
  kc_username: form.kc_username.trim(),
}),
        }
      );

      const result = await response.json();

      if (!response.ok) {
        if (response.status === 409) {
          setPassEmail(form.email.trim());
          setShowPassLookup(true);
          setPassLookupError('');
          throw new Error(
            'You are already registered. Retrieve your verified pass below.'
          );
        }

        throw new Error(
          result.message || 'Registration failed. Please try again.'
        );
      }

      setRegistration(result.data);
    } catch (err) {
      setError(
        err.message ||
          'Unable to complete your registration. Please try again.'
      );
    } finally {
      setLoading(false);
    }
  };

//   const handlePassLookup = async (event) => {
//     event.preventDefault();

//     const email = passEmail.trim().toLowerCase();

//     if (!email) {
//       setPassLookupError('Please enter the email address you registered with.');
//       return;
//     }

//     setPassLookupLoading(true);
//     setPassLookupError('');

//     try {
//       const response = await fetch(
//         `${API_URL}/api/birthday/staff/retrieve-pass`,
//         {
//           method: 'POST',
//           headers: {
//             'Content-Type': 'application/json',
//           },
//           body: JSON.stringify({ email }),
//         }
//       );

//       const result = await response.json();

//       if (!response.ok || !result.success) {
//         throw new Error(
//           result.message ||
//             'We could not find a registered staff pass for that email.'
//         );
//       }

//       const registrationCode = result.data?.registrationCode;

//       if (!registrationCode) {
//         throw new Error('Your pass was found, but no registration code is available.');
//       }

//       navigate(`/verify/${registrationCode}`);
//     } catch (err) {
//       setPassLookupError(
//         err.message ||
//           'Unable to retrieve your pass. Please try again.'
//       );
//     } finally {
//       setPassLookupLoading(false);
//     }
//   };

const handlePassLookup = async (event) => {
  event.preventDefault();

  const kc_username = passKCUsername
    .trim()
    .replace(/^@+/, '');

  if (!kc_username) {
    setPassLookupError(
      'Please enter the KingsChat username you registered with.'
    );
    return;
  }

  setPassLookupLoading(true);
  setPassLookupError('');

  try {
    const response = await fetch(
      `${API_URL}/api/birthday/staff/retrieve-pass`,
      {
        method: 'POST',

        headers: {
          'Content-Type': 'application/json',
        },

        body: JSON.stringify({
          kc_username,
        }),
      }
    );

    const result = await response.json();

    if (!response.ok || !result.success) {
      throw new Error(
        result.message ||
          'We could not find a registered staff pass for that KingsChat username.'
      );
    }

    const registrationCode =
      result.data?.registrationCode;

    if (!registrationCode) {
      throw new Error(
        'Your pass was found, but no registration code is available.'
      );
    }

    navigate(`/verify/${registrationCode}`);
  } catch (err) {
    setPassLookupError(
      err.message ||
        'Unable to retrieve your pass. Please try again.'
    );
  } finally {
    setPassLookupLoading(false);
  }
};


//   const resetRegistration = () => {
//     setForm(initialForm);
//     setRegistration(null);
//     setError('');
//     setShowPassLookup(false);
//     setPassEmail('');
//     setPassLookupError('');
//   };

const resetRegistration = () => {
  setForm(initialForm);
  setRegistration(null);
  setError('');
  setShowPassLookup(false);
  setPassKCUsername('');
  setPassLookupError('');
};

  /**
   * ==========================
   * SUCCESS PAGE
   * ==========================
   */
  if (registration) {
    return (
      <div className="staff-registration-page">
        <PortraitStage />

        <section className="staff-sheet">
          {/* the seal closes the invitation: a check once registered */}
          <div className="staff-seal-slot" aria-hidden="true">
            <motion.div
              className="staff-seal"
              initial={{ opacity: 0, scale: 1.7, rotate: -18 }}
              animate={{ opacity: 1, scale: 1, rotate: -6 }}
              transition={{
                delay: 0.3,
                duration: 0.4,
                ease: [0.2, 0.9, 0.3, 1.15],
              }}
            >
              <span>✓</span>
            </motion.div>
          </div>

          <div className="staff-sheet-inner">
            <span className="staff-registration-eyebrow">
              Registration successful
            </span>

            <h1 className="staff-success-title">
              Thank You, {registration.title} {registration.fullName}
            </h1>

            <p className="staff-registration-intro">
              Your registration for the Thanksgiving Service
              has been confirmed. Please keep your QR code
              available for verification at the venue.
            </p>

            <div className="staff-ticket-wrap">
              <div className="staff-registration-ticket">
                <div className="staff-registration-ticket-copy">
                  <span className="staff-registration-ticket-label">
                    Registration code
                  </span>

                  <strong className="staff-registration-code">
                    {registration.registrationCode}
                  </strong>

                  <div className="staff-registration-details">
                    {registration.title && (
                      <div>
                        <span>Title</span>

                        <strong>
                          {registration.title}
                        </strong>
                      </div>
                    )}

                    <div>
                      <span>Name</span>
                      <strong>
                        {registration.fullName}
                      </strong>
                    </div>

                    {registration.email && (
                      <div className="staff-detail--wide">
                        <span>Email</span>

                        <strong>
                          {registration.email}
                        </strong>
                      </div>
                    )}

                    {registration.kc_username && (
                      <div>
                        <span>KingsChat username</span>

                        <strong>
                          @{registration.kc_username}
                        </strong>
                      </div>
                    )}

                    {registration.department && (
                      <div>
                        <span>Ministry / Zone</span>

                        <strong>
                          {registration.department}
                        </strong>
                      </div>
                    )}

                    <div className="staff-detail--wide">
                      <span>Access</span>

                      <strong>
                        Thanksgiving Service
                      </strong>
                    </div>
                  </div>
                </div>

                <div className="staff-registration-qr-wrap">
                  {registration.qrCode ? (
                    <img
                      src={registration.qrCode}
                      alt={`QR code for ${registration.fullName}`}
                      className="staff-registration-qr"
                    />
                  ) : (
                    <div className="staff-registration-qr-placeholder">
                      QR unavailable
                    </div>
                  )}

                  <span className="staff-registration-qr-caption">
                    Show this at the entrance
                  </span>
                </div>
              </div>
            </div>

            <div className="staff-registration-actions">
              <Link
                to={`/verify/${registration.registrationCode}`}
                className="staff-registration-button staff-registration-button--pass"
              >
                View My Verified Pass
              </Link>

              <Link
                to="/"
                className="staff-registration-button staff-registration-button--ghost"
              >
                Return Home
              </Link>

              <button
                type="button"
                className="staff-registration-button staff-registration-button--ghost"
                onClick={resetRegistration}
              >
                Register Another Staff
              </button>
            </div>

            <p className="staff-registration-tip">
              Tip: take a screenshot of your QR code so it is ready
              at the entrance.
            </p>
          </div>
        </section>
      </div>
    );
  }

  /**
   * ==========================
   * REGISTRATION PAGE
   * ==========================
   */

  return (
    <div className="staff-registration-page">
      <PortraitStage />

      <section className="staff-sheet">
        {/* wax seal on the seam between portrait and letter */}
        <div className="staff-seal-slot" aria-hidden="true">
          <motion.div
            className="staff-seal"
            initial={{ opacity: 0, scale: 1.7, rotate: -18 }}
            animate={{ opacity: 1, scale: 1, rotate: -6 }}
            transition={{
              delay: 1,
              duration: 0.4,
              ease: [0.2, 0.9, 0.3, 1.15],
            }}
          >
            <span>✦</span>
          </motion.div>
        </div>

        <div className="staff-sheet-inner">

          {/* =================================
              THE INVITATION LETTER
          ================================= */}

          <header className="staff-letter">
            <p className="staff-invitation-overline">
              A Celebration of Honour &amp; Thanksgiving
            </p>

            <h1 className="staff-invitation-title">
              You’re Cordially Invited
            </h1>

            <div className="staff-rule" aria-hidden="true">
              <b>✦</b>
              <span />
            </div>

            <div className="staff-invitation-copy">
              <p className="staff-invitation-lead">
                Join us for a special Thanksgiving Service in honour
                of the birthday of the highly esteemed{' '}
                <strong>Chief of Staff, LoveWorld Nation.</strong>
              </p>

              <p className="staff-invitation-instruction">
                Kindly complete the form below to receive your
                personalised invitation and QR pass.
              </p>
            </div>
          </header>


          {/* RETURNING STAFF PASS LOOKUP */}
          <div className="staff-pass-access">
            <button
              type="button"
              className="staff-pass-access-toggle"
              aria-expanded={showPassLookup}
              onClick={() => {
                setShowPassLookup((current) => !current);
                setPassLookupError('');
              }}
            >
              <span className="staff-pass-access-icon">✓</span>
              <span>
                <strong>Already registered?</strong>
                <small>Retrieve your verified pass with your KingsChat username</small>
              </span>
              <span className="staff-pass-access-arrow">
                {showPassLookup ? '−' : '+'}
              </span>
            </button>

            {showPassLookup && (
              <motion.form
                className="staff-pass-lookup-form"
                onSubmit={handlePassLookup}
                initial={{ opacity: 0, height: 0, y: -8 }}
                animate={{ opacity: 1, height: 'auto', y: 0 }}
                transition={{ duration: 0.28 }}
              >
                <label htmlFor="staff-pass-kc-username">
                  KingsChat Username
                </label>

                <div className="staff-pass-lookup-row">
                  <input
                    id="staff-pass-kc-username"
                    type="text"
                    placeholder="Enter your KingsChat username"
                    value={passKCUsername}
                    onChange={(event) => {
                      setPassKCUsername(event.target.value);

                      if (passLookupError) {
                        setPassLookupError('');
                      }
                    }}
                    autoComplete="username"
                    required
                  />

                  <button
                    type="submit"
                    disabled={passLookupLoading}
                  >
                    {passLookupLoading
                      ? 'Finding Pass…'
                      : 'Open My Pass'}
                  </button>
                </div>

                {passLookupError && (
                  <div
                    className="staff-pass-lookup-error"
                    role="alert"
                  >
                    {passLookupError}
                  </div>
                )}

                <p className="staff-pass-lookup-note">
                  We’ll use your registered KingsChat username
                  to locate your event pass.
                </p>
              </motion.form>
            )}
          </div>


          {/* ERROR */}

          {error && (
            <div
              className="staff-registration-alert"
              role="alert"
            >
              {error}
            </div>
          )}


          {/* REGISTRATION FORM */}

          <form
            className="staff-registration-form"
            onSubmit={handleSubmit}
          >
            {/* TITLE */}

            <div className="staff-registration-field">
              <label htmlFor="staff-title">
                Title
              </label>

              <div className="staff-input-wrap">
                <span className="staff-field-icon" aria-hidden="true">
                  <svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round"><path d="M12 3l2.6 5.3 5.9.9-4.3 4.1 1 5.8L12 16.3l-5.2 2.8 1-5.8L3.5 9.2l5.9-.9L12 3z" /></svg>
                </span>

                <input
                  id="staff-title"
                  name="title"
                  type="text"
                  placeholder="e.g. Pastor, Deacon, Dr., Mr., Mrs."
                  value={form.title}
                  onChange={handleChange}
                  autoComplete="honorific-prefix"
                  required
                />
              </div>
            </div>

            {/* FULL NAME */}

            <div className="staff-registration-field">
              <label htmlFor="staff-full-name">
                Full Name
              </label>

              <div className="staff-input-wrap">
                <span className="staff-field-icon" aria-hidden="true">
                  <svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="8" r="4" /><path d="M4 20c0-4 3.6-6 8-6s8 2 8 6" /></svg>
                </span>

                <input
                  id="staff-full-name"
                  name="fullName"
                  type="text"
                  placeholder="Enter your full name"
                  value={form.fullName}
                  onChange={handleChange}
                  autoComplete="name"
                  required
                />
              </div>
            </div>


            {/* EMAIL */}

            {/* <div className="staff-registration-field">
              <label htmlFor="staff-email">
                Email Address
              </label>

              <input
                id="staff-email"
                name="email"
                type="email"
                placeholder="Enter your email address"
                value={form.email}
                onChange={handleChange}
                autoComplete="email"
                required
              />
            </div> */}


            {/* KINGSCHAT */}

            <div className="staff-registration-field">
              <label htmlFor="staff-kc_username">
                Your KingsChat Username
              </label>

              <div className="staff-input-wrap">
                <span className="staff-field-icon" aria-hidden="true">
                  <svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="4" /><path d="M16 8v5a3 3 0 0 0 6 0v-1a10 10 0 1 0-4 8" /></svg>
                </span>

                <input
                  id="staff-kc_username"
                  name="kc_username"
                  type="text"
                  placeholder="Enter your KingsChat username"
                  value={form.kc_username}
                  onChange={handleChange}
                  autoComplete="username"
                  required
                />
              </div>
            </div>


            {/* PHONE */}

            {/* <div className="staff-registration-field">
              <label htmlFor="staff-phone">
                Phone Number
              </label>

              <input
                id="staff-phone"
                name="phone"
                type="tel"
                placeholder="Enter your phone number"
                value={form.phone}
                onChange={handleChange}
                autoComplete="tel"
                required
              />
            </div> */}


            {/* MINISTRY / ZONE */}

            {/* <div className="staff-registration-field">
              <label htmlFor="staff-department">
                Your Ministry / Zone
              </label>

              <input
                id="staff-department"
                name="department"
                type="text"
                placeholder="Enter your Ministry / Zone"
                value={form.department}
                onChange={handleChange}
              />
            </div> */}


            {/* SUBMIT */}

            <motion.button
              type="submit"
              className="staff-registration-submit"
              whileHover={
                !loading
                  ? {
                      scale: 1.01,
                    }
                  : {}
              }
              whileTap={
                !loading
                  ? {
                      scale: 0.99,
                    }
                  : {}
              }
              disabled={loading}
            >
              {loading
                ? 'Registering...'
                : 'Register & Get QR Code'}
            </motion.button>

          </form>


          {/* ACCESS */}

          <div className="staff-registration-note">
            <span>
              <strong>
                Access:
              </strong>{' '}
              Thanksgiving Service
            </span>
          </div>


          <Link
            to="/"
            className="staff-registration-back"
          >
            ← Back to celebration page
          </Link>

        </div>
      </section>
    </div>
  );
}